/**
 * GridFilterButton 컬럼별 필터 — colDef.filterable / filterValueGetter 공통 처리
 *
 * filterable: true  → cellRenderer 여부와 관계없이 필터 대상 포함
 * filterable: false → 필터 대상에서 제외
 * (미지정)          → cellRenderer 없거나 header required 컬럼만 포함 (기존 규칙)
 */

export function isGridFilterTargetColumn(colDef) {
  if (!colDef?.field || String(colDef.field).toLowerCase() === 'no') {
    return false;
  }

  if (colDef.filterable === false) return false;
  if (colDef.filterable === true) return true;

  const isRequired = colDef.headerComponentParams?.required === true;
  if (!colDef.cellRenderer || isRequired) return true;

  return false;
}

export function getGridFilterValue(colDef, data) {
  if (!colDef || !data) return undefined;

  if (typeof colDef.filterValueGetter === 'function') {
    return colDef.filterValueGetter({ data, colDef });
  }

  return data[colDef.field];
}

export function findColumnDefByField(columnDefs, field) {
  if (!Array.isArray(columnDefs) || !field) return null;
  return columnDefs.find((c) => c?.field === field) ?? null;
}

/** 그리드 API colDef 우선 (filterValueGetter 등 런타임 정의 반영) */
export function resolveColumnDefForFilter(field, columnDefs, gridApi) {
  if (gridApi && typeof gridApi.getColumn === 'function') {
    const col = gridApi.getColumn(field);
    const fromGrid = col?.getColDef?.();
    if (fromGrid) return fromGrid;
  }
  return findColumnDefByField(columnDefs, field);
}

export function doesRowPassGridColumnFilters(
  filters,
  data,
  columnDefs,
  gridApi = null
) {
  if (!filters || !data) return true;

  return Object.keys(filters).every((field) => {
    const values = filters[field] || [];
    if (values.length === 0) return true;

    const colDef = resolveColumnDefForFilter(field, columnDefs, gridApi);
    const cellValue = getGridFilterValue(colDef, data);
    return values.includes(cellValue);
  });
}
